import type { FC } from 'react';
import { useIntl } from 'react-intl';

import {
  formatEmployeesNumber,
  formatAmount,
} from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { EntityInfo } from './entity-info';

export const EntityInfoCompany: FC = () => {
  const intl = useIntl();

  const { pageContext } = usePageContext();
  const followersTotal = pageContext.followersTotal;
  const employeesCount = pageContext.employeesCount;
  const companySizeRange = pageContext.companySizeRange;

  const entityInfoData = [];

  if (followersTotal > 0) {
    entityInfoData.push({
      value: formatAmount({ value: followersTotal, intl }),
      label: ` ${intl.formatMessage({
        id: followersTotal > 1 ? 'EP_FOLLOWERS.other' : 'EP_FOLLOWERS.one',
      })}`,
      testId: 'HEADER_FOLLOWERS_TOTAL',
    });
  }

  if (companySizeRange && companySizeRange.min !== companySizeRange.max) {
    entityInfoData.push({
      value: formatEmployeesNumber(
        {
          min: companySizeRange.min ?? 0,
          max: companySizeRange.max,
        },
        intl
      ),
      label: ` ${intl.formatMessage({ id: 'EP_EMPLOYEES' })}`,
      className: 'hideBorderOnLowRes',
      testId: 'HEADER_COMPANY_SIZE',
    });
  }

  if (
    companySizeRange &&
    companySizeRange.min !== companySizeRange.max &&
    employeesCount
  ) {
    entityInfoData.push({
      value: formatAmount({ value: employeesCount, intl }),
      label: ` ${intl.formatMessage({ id: 'EP_ON_XING' })}`,
      className: 'hideOnLowRes',
      testId: 'HEADER_EMPLOYEES_COUNT',
    });
  }

  return <EntityInfo data={entityInfoData} />;
};
